import React from "react";
import styled, { keyframes } from "styled-components";
import company1 from "../../../assets/images/company1.jpeg";
import company2 from "../../../assets/images/contactUs/bulding3.jpg";
import company3 from "../../../assets/images/contactUs/bulding2.jpg";

// Beat animation for the icons
const faBeat = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.18);
  }
`;

// Fade-up on load / scroll feel
const fadeInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(30px) scale(0.98);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

// Section background
const Section = styled.section`
  padding: 80px 20px;
 background: #ffffff;
  position: relative;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    inset: -150px;
    background: radial-gradient(circle at 0% 0%, rgba(7, 182, 242, 0.08), transparent 60%);
    opacity: 0.9;
    pointer-events: none;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

const Title = styled.h2`
  font-family: "Poppins", system-ui;
  font-weight: 700;
  font-size: 2.8em;
  margin-bottom: 40px;
 color: #697d88; /* Dark NexTech Ink */
  text-align: left;
  letter-spacing: 0.02em;

  span {
    color: #00cbf1;
  }

  @media (max-width: 768px) {
    font-size: 2.1em;
  }

  @media (max-width: 480px) {
    font-size: 1.8em;
  }
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
`;

const Col = styled.div`
  flex: 1 1 100%;
  max-width: 100%;
  animation: ${fadeInUp} 0.7s ease forwards;
  opacity: 0;
  animation-delay: ${({ delay }) => delay || 0}s;

  @media (min-width: 768px) {
    flex: 1 1 calc(50% - 24px);
    max-width: calc(50% - 24px);
  }

  @media (min-width: 992px) {
    flex: 1 1 calc(33.333% - 24px);
    max-width: calc(33.333% - 24px);
  }
`;

/* 🔹 Glare overlay that sweeps across on hover */
const Glare = styled.div`
  position: absolute;
  inset: -40%;
  background:
    radial-gradient(circle at 10% 0%, rgba(255, 255, 255, 0.55), transparent 55%),
    background: radial-gradient(circle at 0% 0%, rgba(114, 150, 161, 0.08), transparent 60%);
  mix-blend-mode: screen;
  opacity: 0;
  transform: translate3d(-40%, -40%, 0) rotate(10deg);
  transition: opacity 0.4s ease, transform 0.8s ease;
  pointer-events: none;
`;

const Card = styled.div`
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  padding: 1px; /* gradient border */
 background: linear-gradient(
    135deg,
    rgba(7, 182, 242, 0.4),
    rgba(233, 244, 251, 1),
    rgba(255, 255, 255, 1)
  
  );
  cursor: pointer;
  transform-style: preserve-3d;
  transition:
    transform 0.35s ease,
    box-shadow 0.35s ease,
    background 0.4s ease,
    filter 0.35s ease;

 &:hover {
    transform: translateY(-12px) translateZ(10px) rotateX(-2deg) rotateY(2deg);
    /* 1. Soften the black shadow for a light background */
    box-shadow: 0 24px 50px rgba(10, 42, 59, 0.15); 
    
    /* 2. REMOVE OR COMMENT OUT THIS LINE to get rid of the blue glow */
    /* filter: drop-shadow(0 0 18px rgba(0, 203, 241, 0.4)); */
  }

  /* 🔹 Trigger glare on hover */
  &:hover ${Glare} {
    opacity: 2;
    transform: translate3d(60%, 80%, 0) rotate(60deg);
  }
`;

const CardInner = styled.div`
 background: #ffffff;
  box-shadow: 0 10px 30px rgba(10, 42, 59, 0.08); /* Adds a soft shadow so white cards pop on white background */
  border-radius: 16px;
  overflow: hidden;
  backdrop-filter: blur(14px);
`;

const CardImg = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
`;

const CardBody = styled.div`
  padding: 18px 20px 20px;
`;

const CardTitle = styled.h5`
  font-family: "Poppins", system-ui;
  font-weight: 600;
  font-size: 1.1em;
  margin-bottom: 8px;
  color: #0a2a3b;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CardText = styled.p`
  font-family: "Poppins", system-ui;
  font-weight: 400;
  font-size: 0.95em;
 color: #5e6b74;  
  line-height: 1.7;
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const Icon = styled.i`
  animation: ${faBeat} 2s infinite;
  color: #00cbf1;
  margin-top: 3px;
`;

const OurOffices = () => {
  const locations = [
    {
      image: company1,
      alt: "NexTech PLM Solutions Private Limited",
      title: "NexTech PLM Solutions Pvt Ltd",
      address:
  "NexTech PLM Solutions Pvt. Ltd., 2nd Floor, The Capitol, New DP Rd, Vishal Nagar, Pimple Nilakh, Pune, Pimpri-Chinchwad, Maharashtra 411027",

      mapLink:
        "https://maps.app.goo.gl/nPjk9XgHVn8Jqfyq7",
    },
    {
      image: company2,
      alt: "NexTech PLM Solutions Pvt Ltd New York",
      title: "NexTech PLM Solutions Pvt Ltd",
      address: "635 W 42nd St Suite 37E, New York, NY 10036, USA",
      mapLink: "https://maps.app.goo.gl/PUe92hPZiiCzz6cM7",
    },
    {
      image: company3,
      alt: "NexTech PLM Solutions Pvt Ltd France",
      title: "NexTech PLM Solutions Pvt Ltd",
      address: "11 rue des Draperies, 69450 St-Cyr-au-Mont-d'Or, France",
      mapLink:
        "https://www.google.com/maps?q=11+rue+des+Draperies,+69450+St-Cyr-au-Mont-d'Or,+France",
    },
  ];

  return (
    <Section className="our-offices">
      <Container>
        <Title>
          Our Global <span>Network</span>
        </Title>
        <Row>
          {locations.map((location, index) => (
            <Col key={index} delay={index * 0.15}>
              <a
                href={location.mapLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Card>
                  {/* 🔹 Glare layer */}
                  <Glare />
                  <CardInner>
                    <CardImg src={location.image} alt={location.alt} />
                    <CardBody>
                      <CardTitle>
                        <Icon className="fa-regular fa-building" />
                        {location.title}
                      </CardTitle>
                      <CardText>
                        <Icon className="fa-solid fa-location-dot" />
                        <span>{location.address}</span>
                      </CardText>
                    </CardBody>
                  </CardInner>
                </Card>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </Section>
  );
};

export default OurOffices;
